import { Component, OnInit, ViewChild } from '@angular/core';
import { DataGridSettingModel } from 'src/app/models/data-grid.model';
import { TermService } from 'src/app/services/term.service';
import { CalendarOptions, Calendar } from '@fullcalendar/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { MatDialog } from '@angular/material/dialog';
import timeGridPlugin from '@fullcalendar/timegrid';
import mkLocale from '@fullcalendar/core/locales/mk';
import { AdministrationResultStatus, ConfigurationParameterData, HolidayData, PaginationArgs, ScheduleData, ServiceData, TermData, UserProfileData } from 'src/app/clients/system-api/SystemApiClient';
import { NgForm, FormGroup, FormBuilder } from '@angular/forms';
import { ScheduleService } from 'src/app/services/schedule.service';
import { ConfigurationParameterService } from 'src/app/services/configuration-parameter.service';
import { CalendarRefreshService } from 'src/app/services/calendar.service';
import { ServiceService } from 'src/app/services/service.service';
import { EmployeeService } from 'src/app/services/employee.service';
import { HolidayService } from 'src/app/services/holiday.service';
import * as moment from 'moment';
import { GenericModalComponent } from 'src/app/components/modals/generic-modal/generic-modal.component';
import { WindowDimensions, WindowDimensionsService } from 'src/app/services/window-dimension-service.service';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { WIDTH_CHANGE_THRESHOLD } from '../shift-page/shift-page.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-contract-request-list',
  templateUrl: './term-page.component.html',
  styleUrls: ['./term-page.component.scss']
})
export class TermPageComponent implements OnInit {
  searchForm!: FormGroup;

  //PopUps
  addTermPopupState: boolean = false;
  editTermPopupState: boolean = false;
  addNonWorkingDayPopupState: boolean = false;

  arg:any;
  termId!:number;
  mergeFromDate = new Date();
  mergeToDate = new Date();

  windowDimensions: WindowDimensions = {} as WindowDimensions;
  lastWidthBrakePoint:number | undefined = undefined;

  termData: TermData[] | undefined = [];
  mergedTermData: TermData[] | undefined = [];
  todayTermData: TermData[] | undefined = [];
  scheduleData: ScheduleData[] | undefined = [];
  configurationParameterData: ConfigurationParameterData | undefined;

  selectedDateRange: { start: Date, end: Date } | null = null;
  clientsData: UserProfileData[] | undefined = [];
  selectedServiceId: number | undefined;
  selectedClientId: number | undefined;
  searchNotRegistredUser: string | undefined;
  currentDate = new Date();
  serviceData : ServiceData[] | undefined = [];
  totalMinutesDifference = 0;

  modalRef?: BsModalRef;
  title:any;

  holidayData: HolidayData[] | undefined = [];
  calendarOptions: CalendarOptions = { initialView: 'timeGridWeek', plugins: [timeGridPlugin], };
  dataGridSettings!: DataGridSettingModel;
  
  fullCalendarApi: Calendar | undefined = undefined;

  @ViewChild('searchNgForm') searchNgForm!: NgForm;
  @ViewChild(GenericModalComponent) genericModalComponent!: GenericModalComponent;
  @ViewChild('calendar') fullCalendarComponent!: FullCalendarComponent;
  @ViewChild('template') template! : any;

  constructor(
    private termService: TermService,
    private scheduleService: ScheduleService,
    private configurationParameterService: ConfigurationParameterService,
    public dialog: MatDialog,
    private _formBuilder: FormBuilder,
    private employeeService: EmployeeService,
    private holidayService: HolidayService,
    private serviceService: ServiceService,
    private _windowDimensionsService: WindowDimensionsService,
    public translateService: TranslateService,
    private calendarRefreshService: CalendarRefreshService
  ) { 
    this._windowDimensionsService
    .getWindowDimensions$()
    .subscribe((dimensions) => {
      this.windowDimensions = dimensions;

      if(this.fullCalendarComponent !== undefined && this.fullCalendarApi !== undefined){
        if(this.windowDimensions.width < this.windowDimensions.threshold_lg){
          this.fullCalendarApi.changeView('timeGridDay');
        } else {
          this.fullCalendarApi.changeView('timeGridWeek');
        }
      }

      if(this.lastWidthBrakePoint === undefined || Math.abs(this.windowDimensions.width - this.lastWidthBrakePoint) > WIDTH_CHANGE_THRESHOLD){
        if(this.lastWidthBrakePoint !== undefined){ 
          if(this.fullCalendarApi !== undefined){
            setTimeout(() => {
              if(this.fullCalendarApi !== undefined){ this.fullCalendarApi.updateSize(); }
            }, 500);
          }
        }
        this.lastWidthBrakePoint = this.windowDimensions.width;
      }
    });
  }

  ngOnInit(): void {
    this.searchForm = this._formBuilder.group({
      serviceType: [''],
      active: [''],
    })

    var paginationArgs = new PaginationArgs();
    paginationArgs.skipCount = 0;
    paginationArgs.maxResultCount = 9999;
    paginationArgs.sorting = 'Id ASC';

    this.calendarOptions.initialView = this.windowDimensions.width < this.windowDimensions.threshold_lg ? 'timeGridDay' : 'timeGridWeek';

    this.serviceService.retrieveAllServices(paginationArgs).subscribe(next => {
      this.serviceData = next.content?.items;
    });

    this.scheduleService.retrieveAllSchedules().subscribe(next => {
      this.scheduleData = next.content;
    });

    this.employeeService.retrieveAllUsers(2).subscribe((data) =>{
      this.clientsData = data.content?.items;
    });

    this.calendarRefreshService.refresh$.subscribe(() => {
      this.refreshCalendar();
    });
  }

  public translate(key: string) {
    return this.translateService.instant(key);
  }

  ngAfterViewInit(): void {
    const events: any[] = [];

    var paginationArgs = new PaginationArgs();
    paginationArgs.skipCount = 0;
    paginationArgs.maxResultCount = 9999;
    paginationArgs.sorting = 'Id ASC';

    if(this.fullCalendarComponent !== undefined){
      if(this.fullCalendarApi === undefined){ this.fullCalendarApi = this.fullCalendarComponent.getApi(); }
    }

    this.holidayService.retrieveAllHolidays(paginationArgs).subscribe(next => {
      this.holidayData = next.content!.items;

      for (var i = 0; i < this.holidayData?.length!; i++) {
        var start = new Date(this.holidayData![i].date!)
        start!.setHours(0)
        start!.setMinutes(0)
        start!.setMilliseconds(0)

        var end = new Date(this.holidayData![i].date!)
        end!.setHours(23)
        end!.setMinutes(59)
        end!.setMilliseconds(0)

        const event = { 
          title: this.translateService.instant('Holiday') + ': '+`${this.holidayData![i].name}`,
          start: start,
          end: end,
          display: 'background',
          color: '#75736e',
        };

        events.push(event);
      }
    });

    var paginationArgs = new PaginationArgs({
      skipCount: 0,
      maxResultCount: 9999,
      sorting: 'Id ASC',
      active: true,
    });

    this.termService.retrieveAllTerms(paginationArgs).subscribe(next => {
      if(next.status == AdministrationResultStatus.Success) {
        if(next.content != null && next.content.items != null && next.content.items.length > 0) {
          this.todayTermData = next.content!.items?.filter(x=>x.fromDate?.getDate() == this.currentDate.getDate())
        } else {
          this.todayTermData = [];
        }
      }
    });

    var paginationArgs = new PaginationArgs({
      skipCount: 0,
      maxResultCount: 9999,
      sorting: 'FromDate ASC',
      active: true,
      selectionId2: this.selectedServiceId,
      selectionId: this.selectedClientId,
      searchParam: this.searchNotRegistredUser,
      fromDate: undefined,
      toDate: undefined
    });

    this.termService.retrieveAllTerms(paginationArgs).subscribe(next => {
      this.termData = next.content!.items!
      this.mergedTermData = new Array<TermData>()
      var mergeTermIndex = 0;
      
      this.mergedTermData.push(this.termData![0])//Push the first term

      if (this.termData?.length! > 1) {

        for (var i = 1; i < this.termData?.length!; i++) {
          var term = this.termData![i]

          if ( this.mergedTermData[mergeTermIndex].fromDate! == term.fromDate ||
               this.mergedTermData[mergeTermIndex].toDate! == term.toDate ||
              (this.mergedTermData[mergeTermIndex].toDate! > term.fromDate!)
             ) 
          {
            if (this.mergedTermData[mergeTermIndex].toDate! < term.toDate!) {
              this.mergedTermData[mergeTermIndex].toDate! = new Date(term.toDate!) //Merge
            }
            this.mergedTermData[mergeTermIndex].serviceName! = this.translate("More terms")
          }
          else {
            mergeTermIndex++;
            this.mergedTermData.push(new TermData(this.termData![i])) //Create new merged term
          }
        }
      }

      //Push the merged events

      for (var i = 0; i < this.mergedTermData.length; i++) {
        var mergedTerm = this.mergedTermData![i]

        if(mergedTerm !== undefined){
          const event = { 
            id: (mergedTerm.id !== undefined ? mergedTerm.id : 0).toString(),
            title: mergedTerm.serviceName?.toString(),
            start: new Date(Date.UTC(mergedTerm.fromDate!.getFullYear(), mergedTerm.fromDate!.getMonth(), mergedTerm.fromDate!.getDate(), mergedTerm.fromDate!.getHours(), mergedTerm.fromDate!.getMinutes())),
            end: new Date(Date.UTC(mergedTerm.toDate!.getFullYear(), mergedTerm.toDate!.getMonth(), mergedTerm.toDate!.getDate(), mergedTerm.toDate!.getHours(), mergedTerm.toDate!.getMinutes())),
            color: '#b98d78'
          };
  
          events.push(event);
        }
      }

      var minDate: moment.Moment | undefined = undefined;
      var maxDate: moment.Moment | undefined = undefined;
  
      this.configurationParameterService.retrieveActiveConfigurationParameter().subscribe(next => {
        this.configurationParameterData = next.content;
  
        if(this.configurationParameterData && this.configurationParameterData.workingHours && this.configurationParameterData.workingHours.length > 0){
          this.configurationParameterData?.workingHours?.forEach((config) => {
            if(config.fromTime && config.toTime && config.working){
              var compareMinDate = moment().utc(true);
              compareMinDate.set('hours', moment(config.fromTime).utc(true).get('hours'));
              compareMinDate.set('minutes', moment(config.fromTime).utc(true).get('minutes'));

              var compareMaxDate = moment().utc(true);
              compareMaxDate.set('hours', moment(config.toTime).utc(true).get('hours'));
              compareMaxDate.set('minutes', moment(config.toTime).utc(true).get('minutes'));
              
              if(minDate === undefined){
                minDate = moment().utc(true);
                minDate.set('hours', compareMinDate.get('hours'));
                minDate.set('minutes', compareMinDate.get('minutes'));
              } else {
                if(compareMinDate < minDate){
                  minDate.set('hours', compareMinDate.get('hours'));
                  minDate.set('minutes', compareMinDate.get('minutes'));
                }
              }

              if(maxDate === undefined){
                maxDate = moment().utc(true);
                maxDate.set('hours', compareMaxDate.get('hours'));
                maxDate.set('minutes', compareMaxDate.get('minutes'));
              } else {
                if(compareMaxDate > maxDate){
                  maxDate.set('hours', compareMaxDate.get('hours'));
                  maxDate.set('minutes', compareMaxDate.get('minutes'));
                }
              }
            }
          });
    
          this.calendarOptions= {
            timeZone: 'Europe/Skopje', 
            firstDay: 1,
            weekNumberCalculation: 'ISO',
            slotMinTime: minDate !== undefined ? minDate.get('hours').toString().padStart(2, '0') + ':' + minDate.get('minutes').toString().padStart(2, '0') : '00:00',
            dayHeaderContent: (args) => {
              const dayNames = [
                this.translateService.instant('Sun').toUpperCase(),
                this.translateService.instant('Mon').toUpperCase(),
                this.translateService.instant('Tue').toUpperCase(),
                this.translateService.instant('Wed').toUpperCase(),
                this.translateService.instant('Thu').toUpperCase(),
                this.translateService.instant('Fri').toUpperCase(),
                this.translateService.instant('Sat').toUpperCase(), 
              ];
              const dayName = dayNames[moment(args.date).utc(true).clone().toDate().getDay()];
              const dayNumber = moment(args.date).utc(true).clone().toDate().getDate();
              return `${dayName} - ${dayNumber}`;
            },
            slotLabelFormat: {
              hour: 'numeric',
              minute: '2-digit',
              omitZeroMinute: false,
              meridiem: 'short',
              hour12: false,
            },
            height: "auto",
            themeSystem: 'bootstrap',
            slotMaxTime: maxDate !== undefined ? maxDate.get('hours').toString().padStart(2, '0') + ':' + maxDate.get('minutes').toString().padStart(2, '0') : '00:00',
            allDaySlot: false,
            slotDuration: { hours: 1 },
            slotLabelInterval: { hours: 1 },
            events: events || [],
            eventTimeFormat: {
              hour: '2-digit',
              minute: '2-digit',
              hour12: false
            },
            eventColor: "#b98d78",
            eventTextColor:'#fff',
            dayHeaderClassNames: [ 'myclassname', 'otherclassname' ],
            select: this.handleDateSelect.bind(this),
            eventClick: this.handleDateClick.bind(this),    
            customButtons: {
              customButton: {
                text: this.translate('Add term'),
                click: this.addTermButton.bind(this)
              },
              holidayButton: {
                text: this.translate('Non working days'),
                click: this.holidayDayButton.bind(this)
              }
            },
            headerToolbar: {
              left: 'prev,next today',
              center: 'title',
              right: 'customButton holidayButton'
            },
            buttonText: {
              today: this.translate('today'),
            }
          };
        }
      });  
    });
   
  }

  handleDateClick(arg: any){
    if (arg.event._def.ui.display == "background") {
      return;
    }

    const termId = arg.event.id;
    
    var mergedTerm = this.mergedTermData?.filter(x => x.id == termId)
    this.arg=arg;
    this.termId = termId;
    this.mergeFromDate = mergedTerm![0].fromDate!;
    this.mergeToDate = mergedTerm![0].toDate!;

    this.toggleEditTermPopup(true, this.arg, this.termId, this.mergeFromDate!, this.mergeToDate);

  }  

  refreshCalendar() {
    this.ngAfterViewInit();
  }

  calculateTotalMinutesDifference(term: TermData): number {
    const startTime = term.fromDate!.getTime();
    const endTime = term.toDate!.getTime();

    const timeDifference = endTime - startTime;

    const totalMinutes = Math.floor(timeDifference / (1000 * 60));

    return totalMinutes;
  }

  handleDayRender(dayRenderInfo: any) {
    const sundayIndex = 0; // Sunday is the first day of the week in FullCalendar
    const currentDayIndex = dayRenderInfo.date.getDay();
  
    if (currentDayIndex === sundayIndex) {
      dayRenderInfo.dayEl.classList.add('fc-disabled-day');
    }
  }

  isSundayInDateRange(startDate: Date, endDate: Date): boolean {
    const sundayIndex = 0; // Sunday is the first day of the week in FullCalendar
    const startDayIndex = startDate.getDay();
    const endDayIndex = endDate.getDay();
  
    // Check if either the start or end day is a Sunday
    return startDayIndex === sundayIndex || endDayIndex === sundayIndex;
  }

  handleDateSelect(selectInfo: any) {
    const selectedStartDate = selectInfo.start;
    const selectedEndDate = selectInfo.end;
  
    // Save the selected date range to the component property
    this.selectedDateRange = { start: selectedStartDate, end: selectedEndDate };
  
    // Check if the selected date range includes a Sunday
    if (this.isSundayInDateRange(selectedStartDate, selectedEndDate)) {
      // Clear the selection and inform the user
      alert('Sundays are disabled!');
    }
  }

  addTermButton() {
    this.toggleAddTermPopup();
  }

  holidayDayButton() {
    this.toggleNonWorkingDayPopup();
  }

  formatDate(date: string | Date | undefined): string | undefined {
    if (!date) {
      return undefined;
    }

    const formattedDate = new Date(date).toISOString();
  
    return formattedDate;
  }

  //Popups
  public toggleAddTermPopup(state?: boolean) {
    this.addTermPopupState = false;
    this.addTermPopupState = state ?? !this.addTermPopupState;
  }

  public toggleEditTermPopup(state?: boolean, arg?:any, termId?:number, mergeDateFrom?:Date, mergeDateTo?:Date) {
    this.editTermPopupState = false;
    this.editTermPopupState = state ?? !this.editTermPopupState;
    this.arg = arg;
    this.termId=termId!;
    this.mergeFromDate = mergeDateFrom!;
    this.mergeToDate = mergeDateTo!;
  }

  public toggleNonWorkingDayPopup(state?: boolean) {
    this.addNonWorkingDayPopupState = false;
    this.addNonWorkingDayPopupState = state ?? !this.addNonWorkingDayPopupState;
  }

  closePopupOnButton() {
    this.genericModalComponent.handleClose(true);
    this.addTermPopupState = false;
    this.editTermPopupState = false;
    this.addNonWorkingDayPopupState = false;
    this.refreshCalendar();
  }
}



